(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-chapitre"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.currentScript ? document.currentScript.closest('.rc') : document.querySelector('.rc');
  if (!root) return;
  var articleId = root.dataset.articleId;

  /* ---- Taille du texte (échelle partagée avec le reste du site) ---- */
  var content = document.getElementById('rc-content-' + articleId);
  var FONT_KEY = 'iqra_article_font_scale';
  var STEPS = [0.875, 1, 1.125, 1.25, 1.4];
  var fontIdx = 1;
  try {
    var savedScale = parseFloat(localStorage.getItem(FONT_KEY));
    var found = STEPS.indexOf(savedScale);
    if (found > -1) fontIdx = found;
  } catch (e) {}
  var baseSize = 16.8;
  var pctEls = document.querySelectorAll('.rc-font-pct-inline');
  function applyFont () {
    if (content) content.style.fontSize = (baseSize * STEPS[fontIdx]) + 'px';
    var pctLabel = document.getElementById('rc-font-pct');
    if (pctLabel) pctLabel.textContent = Math.round(STEPS[fontIdx] * 100) + '%';
    pctEls.forEach(function (el) { el.textContent = Math.round(STEPS[fontIdx] * 100) + '%'; });
    try { localStorage.setItem(FONT_KEY, STEPS[fontIdx]); } catch (e) {}
  }
  document.querySelectorAll('[data-rc-font]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.dataset.rcFont === 'inc') fontIdx = Math.min(STEPS.length - 1, fontIdx + 1);
      else fontIdx = Math.max(0, fontIdx - 1);
      applyFont();
    });
  });
  applyFont();

  /* ---- Marquer comme lu ---- */
  var READ_KEY = 'murmures_chapitres_lus';
  function getRead () { try { return JSON.parse(localStorage.getItem(READ_KEY)) || {}; } catch (e) { return {}; } }
  function setRead (map) { try { localStorage.setItem(READ_KEY, JSON.stringify(map)); } catch (e) {} }
  function refreshReadButtons () {
    var isRead = !!getRead()[articleId];
    document.querySelectorAll('[data-rc-mark-read]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', isRead ? 'true' : 'false');
      var label = btn.querySelector('.rc-read-label');
      if (label) label.textContent = isRead ? 'Lu ✓' : 'Marquer comme lu';
    });
  }
  document.querySelectorAll('[data-rc-mark-read]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var map = getRead();
      if (map[articleId]) { delete map[articleId]; } else { map[articleId] = Date.now(); }
      setRead(map);
      refreshReadButtons();
    });
  });
  refreshReadButtons();

  /* ---- Panneau réglages ---- */
  var panel = document.getElementById('rc-settings');
  var backdrop = document.getElementById('rc-settings-backdrop');
  function openSettings () { panel.hidden = false; backdrop.hidden = false; }
  function closeSettings () { panel.hidden = true; backdrop.hidden = true; }
  document.querySelectorAll('[data-rc-settings-open]').forEach(function (btn) {
    btn.addEventListener('click', openSettings);
  });
  var closeBtn = document.getElementById('rc-settings-close');
  if (closeBtn) closeBtn.addEventListener('click', closeSettings);
  if (backdrop) backdrop.addEventListener('click', closeSettings);

  /* ---- Accessibilité (branché sur le système global iqra-a11y) ---- */
  document.querySelectorAll('[data-rc-a11y]').forEach(function (btn) {
    var key = btn.dataset.rcA11y;
    function refresh () {
      var active = document.body.classList.contains('iqra-' + key);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      if (typeof window.iqraA11yToggle === 'function') window.iqraA11yToggle(key);
      else document.body.classList.toggle('iqra-' + key);
      refresh();
    });
    refresh();
  });

  /* ---- Défilement automatique ---- */
  var PREFS_KEY = 'murmures_lecture_prefs';
  function getPrefs () { try { return JSON.parse(localStorage.getItem(PREFS_KEY)) || {}; } catch (e) { return {}; } }
  function setPrefs (p) { try { localStorage.setItem(PREFS_KEY, JSON.stringify(p)); } catch (e) {} }
  var prefs = getPrefs();
  var autoScrollBtn = document.getElementById('rc-autoscroll-toggle');
  var speedRow = document.getElementById('rc-speed-row');
  var speedInput = document.getElementById('rc-speed');
  var autoNextBtn = document.getElementById('rc-autonext-toggle');
  var scrollTimer = null;

  function stopAutoScroll () { if (scrollTimer) { clearInterval(scrollTimer); scrollTimer = null; } }
  function startAutoScroll () {
    stopAutoScroll();
    var speed = parseInt((speedInput && speedInput.value) || '3', 10);
    var pxPerTick = speed * 0.6;
    scrollTimer = setInterval(function () { window.scrollBy(0, pxPerTick); }, 40);
  }
  function refreshAutoScrollUI () {
    var on = !!prefs.autoscroll;
    if (autoScrollBtn) autoScrollBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (speedRow) speedRow.style.display = on ? 'flex' : 'none';
  }
  if (speedInput && prefs.autoscrollSpeed) speedInput.value = prefs.autoscrollSpeed;
  if (autoScrollBtn) {
    autoScrollBtn.addEventListener('click', function () {
      prefs.autoscroll = !prefs.autoscroll;
      setPrefs(prefs);
      refreshAutoScrollUI();
      if (prefs.autoscroll) startAutoScroll(); else stopAutoScroll();
    });
  }
  if (speedInput) {
    speedInput.addEventListener('input', function () {
      prefs.autoscrollSpeed = speedInput.value;
      setPrefs(prefs);
      if (prefs.autoscroll) startAutoScroll();
    });
  }
  refreshAutoScrollUI();
  if (prefs.autoscroll) startAutoScroll();
  window.addEventListener('wheel', stopAutoScroll, { passive: true });
  window.addEventListener('touchstart', stopAutoScroll, { passive: true });

  if (autoNextBtn) {
    autoNextBtn.setAttribute('aria-pressed', prefs.autonext ? 'true' : 'false');
    autoNextBtn.addEventListener('click', function () {
      prefs.autonext = !prefs.autonext;
      setPrefs(prefs);
      autoNextBtn.setAttribute('aria-pressed', prefs.autonext ? 'true' : 'false');
    });
  }

  /* ---- Avancer automatiquement au chapitre suivant en fin de lecture ---- */
  var sentinel = document.getElementById('rc-end-sentinel-' + articleId);
  var nextLink = document.querySelector('.rc-nav-next[href]');
  if (sentinel && nextLink && 'IntersectionObserver' in window) {
    var fired = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !fired && getPrefs().autonext) {
          fired = true;
          setTimeout(function () { window.location.href = nextLink.href; }, 1800);
        }
      });
    }, { threshold: 1 });
    obs.observe(sentinel);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-romans"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.getElementById('rl-grid');
  var empty = document.getElementById('rl-empty');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.rl-card'));
  var searchInput = document.getElementById('rl-search-input');
  var sortSelect = document.getElementById('rl-sort');
  var filters = { statut: '', genre: '' };

  function applyFilters () {
    var q = (searchInput.value || '').toLowerCase().trim();
    var visibleCount = 0;
    cards.forEach(function (card) {
      var text = (card.dataset.title + ' ' + card.dataset.author).toLowerCase();
      var matchesSearch = !q || text.indexOf(q) > -1;
      var matchesStatut = !filters.statut || card.dataset.statut === filters.statut;
      var genres = (card.dataset.genres || '').split('|');
      var matchesGenre = !filters.genre || genres.indexOf(filters.genre) > -1;
      var visible = matchesSearch && matchesStatut && matchesGenre;
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });
    empty.hidden = visibleCount !== 0;
  }

  function applySort () {
    var mode = sortSelect.value;
    var sorted = cards.slice().sort(function (a, b) {
      if (mode === 'popular') return (b.dataset.vues - a.dataset.vues);
      if (mode === 'rating') return (b.dataset.note - a.dataset.note);
      if (mode === 'alpha') return a.dataset.title.localeCompare(b.dataset.title);
      return (b.dataset.created - a.dataset.created);
    });
    sorted.forEach(function (card) { grid.appendChild(card); });
  }

  searchInput.addEventListener('input', applyFilters);
  sortSelect.addEventListener('change', applySort);

  document.querySelectorAll('.rl-filter-group').forEach(function (group) {
    var type = group.dataset.filterType;
    group.querySelectorAll('.rl-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        group.querySelectorAll('.rl-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        filters[type] = chip.dataset.value;
        applyFilters();
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roman-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-rd-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[data-rd-tab]');
    var panels = wrap.querySelectorAll('[data-rd-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var target = wrap.querySelector('[data-rd-panel="' + tab.dataset.rdTab + '"]');
        if (target) target.classList.add('is-active');
      });
    });
  });

  // Ouvre l'onglet indiqué par l'ancre d'URL (#toc, #platforms, #reviews, #reco, #about)
  var hashTab = (window.location.hash || '').replace('#', '');
  if (hashTab) {
    document.querySelectorAll('[data-rd-tabs]').forEach(function (wrap) {
      var target = wrap.querySelector('[data-rd-tab="' + hashTab + '"]');
      if (target) target.click();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
